<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="row">
                        <h5 class="col-sm-12 col-md-8 text-bold">{{ __('Shipping documents') }}</h5>

                        <div class="col-sm-12 col-md-2 right">
                            <button
                                @click="filterShipping"
                                class="btn btn-sm btn-red w-100"
                                type="button"
                            >
                                {{ __('Filter') }}
                            </button>
                        </div>

                        <div class="col-sm-12 col-md-2 right">
                            <router-link
                                class="btn btn-sm btn-cyan w-100"
                                to="/shipping-document-create"
                            >
                                {{ __('New shipment document') }}
                            </router-link>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Shipping date') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <DateTimePicker
                                        :placeholder="__('Select date and time')"
                                        @change="formatShippingDate"
                                        format="YYYY-MM-DD HH:mm"
                                        name="shipping_date_date_from"
                                        type="datetime"
                                        v-model="shippingDocument.date"
                                        value-type="datetime"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Carrier') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <Autocomplete
                                        :fetch-callback="$api.autocomplete.shippingDocumentsCarriers"
                                        :placeholder="__('Select carrier')"
                                        @input="(item) => shippingDocument.carrierCustomer = item.value"
                                        @selected="(item) => shippingDocument.carrierCustomer = item.value"
                                        name="shipping_date_date_from"
                                        value-selector="label"
                                    >
                                        <div slot-scope="result">
                                            {{ result.result.label }}
                                        </div>
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Transport ID number') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <FormInput
                                        name="shipping_transport_id"
                                        type="text"
                                        v-model="shippingDocument.transport"
                                    ></FormInput>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Sender') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <Autocomplete
                                        :fetch-callback="$api.autocomplete.shippingDocumentsSenders"
                                        :placeholder="__('Select sender')"
                                        @input="(item) => shippingDocument.senderCustomer = item.value"
                                        @selected="(item) => shippingDocument.senderCustomer = item.value"
                                        value-selector="label"
                                    >
                                        <div slot-scope="result">
                                            {{ result.result.label }}
                                        </div>
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Recipient') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <Autocomplete
                                        :fetch-callback="$api.autocomplete.shippingDocumentsReceivers"
                                        :placeholder="__('Select recipient')"
                                        @input="(item) => shippingDocument.receiverCustomer = item.value"
                                        @selected="(item) => shippingDocument.receiverCustomer = item.value"
                                        value-selector="label"
                                    >
                                        <div slot-scope="result">
                                            {{ result.result.label }}
                                        </div>
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Recipient address') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <FormInput
                                        name="shippping_recipient_address"
                                        type="text"
                                        v-model="shippingDocument.receiverAddress"
                                    ></FormInput>
                                </div>
                            </div>
                        </div>


                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    {{ __('Status') }}
                                </div>

                                <div class="col-sm-12 col-md-7">
                                    <Autocomplete
                                        :fetch-callback="$api.autocomplete.shippingDocumentsStates"
                                        :placeholder="__('Select status')"
                                        @input="(item) => shippingDocument.state = item.value"
                                        @selected="(item) => shippingDocument.state = item.value"
                                        value-selector="label"
                                    >
                                        <div slot-scope="result">
                                            {{ result.result.label }}
                                        </div>
                                    </Autocomplete>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-sm-12 col-md-5"></div>

                                <div class="col-sm-12 col-md-7"></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-10">&nbsp;</div>

                        <div class="col-sm-12 col-md-2 pul-right">
                            <button
                                @click="exportReleases"
                                class="btn btn-sm btn-primary w-100"
                                type="button"
                            >
                                {{ __('Export XLS') }}
                            </button>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-12 card-nopadding">
                            <wi-table
                                :default-params="{ sort: 'createdAt', order: 'desc'}"
                                :disable-pagination="true"
                                :disable-search="true"
                                :disableHeader="true"
                                :fetch-callback="fetch"
                                ref="shippingTable"

                            >
                                <wi-table-column field="id" sortable>#</wi-table-column>
                                <wi-table-column
                                    class="text-nowrap"
                                    field="receiveDocument.label"
                                    sortable>
                                    {{ __('Receipt doc.') }}
                                </wi-table-column>
                                <wi-table-column field="shipment.label" sortable>{{ __('Load') }}</wi-table-column>
                                <wi-table-column field="shipmentSize.label">{{ __('Size') }}</wi-table-column>
                                <wi-table-column field="carrierCustomer.label">{{ __('Carrier') }}</wi-table-column>
                                <wi-table-column field="receiverCustomer.label">{{ __('Recipient') }}</wi-table-column>
                                <wi-table-column field="state.label">{{ __('Status') }}</wi-table-column>
                                <wi-table-column :render="dateFormat" field="date">{{ __('Date') }}</wi-table-column>
                                <wi-table-column field="shippingQuantity">{{ __('Shipping qty.') }}</wi-table-column>
                                <template slot="actions" slot-scope="{ item }">
                                    <router-link
                                        :to="`/shipping-document/${item.id}/edit`"
                                        class="btn btn-outline-secondary btn-sm mr-1"
                                        v-if="item.state.value === 0"
                                    >
                                        {{ __('Edit') }}
                                    </router-link>

                                    <button
                                        @click="remove(item.id)"
                                        class="btn btn-outline-secondary btn-sm"
                                        v-if="item.state.value === 0"
                                    >
                                        {{ __('Delete') }}
                                    </button>

                                    <router-link
                                        :to="`/shipping-document/${item.id}/view`"
                                        class="btn btn-outline-secondary btn-sm mr-1"
                                        v-if="item.state.value === 1"
                                    >
                                        {{ __('View') }}
                                    </router-link>
                                </template>
                            </wi-table>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
import moment from 'moment'
import { __ } from '../../translations/localization'

export default {
  name: 'ShippingDocuments',

  data () {
    return {
      shippingDocument: {
        date: null,
        carrierCustomer: null,
        transport: null,
        senderCustomer: null,
        receiverCustomer: null,
        receiverAddress: null,
        state: null
      }
    }
  },

  methods: {
    dateFormat (item) {
      return moment(item.date).format('YYYY-MM-DD')
    },

    filterShipping () {
      return this.$api.shipping.list(this.shippingDocument)
    },

    fetch (params = []) {
      return this.$api.shipping.list(params)
    },

    formatShippingDate (date) {
      this.shippingDocument.date = moment(date).format('YYYY-MM-DD HH:mm')
      return this.shippingDocument.date
    },

    exportReleases () {
      return this.$api.shipping.download(this.shippingDocument)
    },

    remove (id) {
      this.$modal.confirm(
        __('Are you sure want to remove this Shipping Document?'),
        () => {
          return this.$api.shipping.delete(id).then(() => {
            this.$toaster.success(__('Shipping document was successfully removed'))
            this.$refs.shippingTable.updateTable()
          })
        })
    }
  }
}
</script>
